import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Divider,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "TranslationContext";

function RestrictedFeatureModel({ isOpen, onClose }) {
  const {translate} = useTranslation();
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent textAlign="center" maxW={{base:"300px",md:"510px"}}>
          <ModalHeader>
            <Flex w="full" justifyContent={"center"}>
              <Flex direction="column" align="center" w="fit-content">
                <Text color={"#595959"} fontSize={"35px"} fontWeight={"500"}>
                  {translate["smscommandinfosc9"]}
                </Text>
                <Divider borderColor="#595959" w="100%" />
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalBody px={1} py={0}>
            <Text fontSize={"18px"} mb={1} color={"#595959"}>
              {translate["planDoesntSupportFeature"]}
              <Text fontSize={"19px"} color={"#595959"} fontWeight="500">
                {translate["contactRetailer"]}
              </Text>
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Button
              mt="5px"
              fontSize={"14px"}
              w="100px"
              bg="#009a51"
              _hover={{ bg: "#01914b" }}
              borderRadius="6px"
              px={8}
              onClick={onClose}
            >
              {translate["ok"]}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default RestrictedFeatureModel;
